module.exports = emdataview;